import app from '@/app';
import templateUrl from './pivot-table-unifilar-all.html';

/* ======================================================================================================
[Sprint Jan-2025] [US 126] [46h] Visualização de TODO o unifilar de parâmetros na tela do sistema (start)
====================================================================================================== */
/* @ngInject */
function controller($translate, wfPivotUtilsUnifilarAll) {
	const $ctrl = this;

	const ZERO = String.fromCharCode(0);

	const kpiMetrics = ['D0', 'ATR', 'FC2', 'FC3', 'IGG', 'IRI', 'URCI'];

	// HS is a band criterion: the configured limits are the bounds of the acceptable
	// range, so any value outside of it fails. There is no regular band for it.
	const BAND_METRICS = ['HS'];

	// VRD, GN and IFI have a single configured threshold, the good limit: at or above
	// it the criterion is met, below it it is not. They have no regular band, and
	// their bad limit is not used at all.
	const SINGLE_LIMIT_METRICS = ['VRD', 'GN', 'IFI'];

	const GOOD_COLOR = 'rgb(173, 238, 173)';
	const REGULAR_COLOR = 'rgb(238, 238, 138)';
	const BAD_COLOR = 'rgb(238, 84, 84)';

	const DEFAULT_OPTIONS = {
		cols: [],
		rows: [],
		translations: {},
		aggregator: wfPivotUtilsUnifilarAll.aggregators.count(),
		formatter: wfPivotUtilsUnifilarAll.formatters.number(3)
	};

	function spanLoop(keys, fast, slow, pre, pos) {
		for (let index = 0; index <= slow; ++index) {
			if (keys[fast - pre][index].value !== keys[fast + pos][index].value) {
				return true;
			}
		}
		return false;
	}

	$ctrl.spanDraw = function(keys, fast, slow) {
		return fast === 0 || spanLoop(keys, fast, slow, 1, 0);
	};

	$ctrl.spanSize = function(keys, fast, slow) {
		let len = 0;
		while (fast + len < keys.length && !spanLoop(keys, fast, slow, 0, len)) {
			++len;
		}
		return len;
	};

	const flatKey = (...entries) =>
		entries.map(keys => keys.map(key => key.value).join(ZERO)).join(ZERO + ZERO);

	const makeKey = (keys, item) =>
		keys.map(key => ({
			name: key.name || key,
			value: item[key.name || key],
			formatter: key.formatter
		}));

	const keySort = keys => (lhs, rhs) =>
		keys
			.map((key, index) =>
				(key.sorter || wfPivotUtilsUnifilarAll.sorters.naturalSort)(
					lhs[index].value,
					rhs[index].value
				)
			)
			.find(value => value != 0) || 0;

	$ctrl.$onChanges = function(changes) {
		Object.assign($ctrl, DEFAULT_OPTIONS, $ctrl.options);

		const rowKeys = {};
		const colKeys = {};
		const tree = {};
		if ($ctrl.model) {
			for (let item of $ctrl.model) {
				const rowKey = makeKey($ctrl.rows, item);
				const colKey = makeKey($ctrl.cols, item);
				const flatRowKey = flatKey(rowKey);
				const flatColKey = flatKey(colKey);
				const flatAllKey = flatKey(rowKey, colKey);

				if (rowKey.length !== 0 && !rowKeys[flatRowKey]) {
					rowKeys[flatRowKey] = rowKey;
				}

				if (colKey.length !== 0 && !colKeys[flatColKey]) {
					colKeys[flatColKey] = colKey;
				}

				if (colKey.length !== 0 && rowKey.length !== 0) {
					if (!tree[flatAllKey]) {
						tree[flatAllKey] = $ctrl.aggregator();
					}
					tree[flatAllKey].push(item);
				}
			}

			$ctrl.rowKeys = Object.values(rowKeys).sort(keySort($ctrl.rows));
			$ctrl.colKeys = Object.values(colKeys).sort(keySort($ctrl.cols));
			$ctrl.tree = tree;
		}
	};

	$ctrl.formatHead = head => $translate.instant(head.translation || head.type || head);
	$ctrl.formatNeck = neck => (neck.formatter ? neck.formatter(neck.value) : neck.value);

	$ctrl.aggregatorOf = (rowKey, colKey) => $ctrl.tree[flatKey(rowKey, colKey)];

	$ctrl.valueOfAggregator = aggregator => aggregator && aggregator.value && aggregator.value();
	$ctrl.valueOf = (rowKey, colKey) => $ctrl.valueOfAggregator($ctrl.aggregatorOf(rowKey, colKey));

	$ctrl.styleOfAggregator = aggregator => aggregator && aggregator.style && aggregator.style();
	$ctrl.styleOf = (rowKey, colKey) => $ctrl.styleOfAggregator($ctrl.aggregatorOf(rowKey, colKey));

	const roundToTwoDecimals = value => {
		if (value === null || value === undefined || value === '' || !isFinite(value)) {
			return '';
		}
		return Math.round(value * 100) / 100;
	};

	$ctrl.valueFor = (rowKey, metric, lane, direction) => {
      if (!$ctrl.model || !$ctrl.model.length) return '';

      const item = $ctrl.model.find(i =>
        i.headMilestone === rowKey[0].value &&
        i.lane === lane &&
        i.direction === direction
      );

      if (!item) return '';

      const value = item[metric];

      const metricHandlers = {
        fc2: v => isFinite(v) ? `${Math.round(v * 100)}%` : '',
        fc3: v => isFinite(v) ? `${Math.round(v * 100)}%` : '',
        igg: v => isFinite(v) ? Math.round(v) : '',
        iri: v => isFinite(v) ? Math.round(v * 100) / 100 : '',
        vrd: roundToTwoDecimals,
        gn: roundToTwoDecimals
      };

      if (metricHandlers[metric]) {
        return metricHandlers[metric](value);
      }

      const segmentMetrics = [
        'dateConclusion', 'expectedSolution', 'workItem',
        'startDate', 'endDate', 'comments'
      ];

      if (segmentMetrics.includes(metric)) {
        const seg = item.segmentsFiltered && item.segmentsFiltered.length > 0 ? item.segmentsFiltered[0] : null;
        return seg && seg[metric] !== undefined ? seg[metric] : '';
      }

      return value !== undefined && value !== null && value !== 'NaN'? value : '';
	};

	$ctrl.valueForMetric = (rowKey, metric, lane, direction) => {
		for (let item of $ctrl.model) {
			if (
				rowKey[0].value == item.headMilestone
				&& item.lane == lane
				&& item.direction == direction
			) {
				if(metric == 'fc3' && lane == 2 && direction == 'INC'){
					console.log(metric + "-" + direction + "-" + lane + "-" + item[metric]);
				}

				return item[metric] > 0 ? item[metric] : 0;
			}
		}
	};

	$ctrl.metricString = () => {
		return $ctrl.metric.replace('KPI_', '');
	};

	var isUnifilarMetric = function() {
		//var metricString= $ctrl.metric.replace("KPI_", "");
		if (kpiMetrics.indexOf($ctrl.metricString()) !== -1) {
			return true;
		} else {
			return false;
		}
	};

	// Inside the configured range = meets the criterion, outside of it = fails.
	// The bounds are taken as min/max so the order in which they were configured
	// does not change the outcome.
	var checkBandLimitStyle = function(value, badLimit, goodLimit) {
		var lowerBound = Math.min(badLimit, goodLimit);
		var upperBound = Math.max(badLimit, goodLimit);

		if (value >= lowerBound && value <= upperBound) {
			return GOOD_COLOR;
		}
		return BAD_COLOR;
	};

	var checkSingleLimitStyle = function(value, goodLimit) {
		if (value >= goodLimit) {
			return GOOD_COLOR;
		}
		return BAD_COLOR;
	};

	var checkLowerIsBetterLimitStyle = function(value, badLimit, goodLimit) {
		if (value >= badLimit) {
			return BAD_COLOR;
		}
		if (value <= goodLimit) {
			return GOOD_COLOR;
		}
		return REGULAR_COLOR;
	};

	var checkLimitStyle = function(metric, value) {

		var badLimitString = 'badLimit' + metric;
		var badLimit = $ctrl.criteria[badLimitString];

		var goodLimitString = 'goodLimit' + metric;
		var goodLimit = $ctrl.criteria[goodLimitString];

		if(metric == 'FC2' || metric == 'FC3'){
			badLimit = badLimit / 100;
			goodLimit = goodLimit / 100;

			if(value){
				value  = parseFloat(value.replace('%', '')) / 100;
			}

		}

		// Limits default to NaN when the criteria set does not configure the metric;
		// leave the cell uncoloured instead of falling into an arbitrary band.
		if (isNaN(goodLimit)) {
			return 'transparent';
		}

		if (SINGLE_LIMIT_METRICS.indexOf(metric) !== -1) {
			return checkSingleLimitStyle(value, goodLimit);
		}

		if (isNaN(badLimit)) {
			return 'transparent';
		}

		if (BAND_METRICS.indexOf(metric) !== -1) {
			return checkBandLimitStyle(value, badLimit, goodLimit);
		}

		return checkLowerIsBetterLimitStyle(value, badLimit, goodLimit);
	};

	var checkLimitStyleD0 = function(metric, value, dadmValue) {

		var badLimitString = 'badLimit' + metric;
		var badLimit = $ctrl.criteria[badLimitString] * dadmValue;

		var goodLimitString = 'goodLimit' + metric;
		var goodLimit = $ctrl.criteria[goodLimitString] * dadmValue;

		if (isNaN(badLimit) || isNaN(goodLimit)) {
			return 'transparent';
		}

		return checkLowerIsBetterLimitStyle(value, badLimit, goodLimit);
	};

	$ctrl.styleOfMetric = function(metric, value) {
    if(!value){
			return 'transparent';
		}
		if(value != 0 && value == ''){
			return 'transparent';
		}
		if (metric) {
			return checkLimitStyle(metric, value);
		} else {
			return 'transparent';
		}
	};

	$ctrl.styleOfMetricD0 = function(metric, value, dadmValue) {
		if(value == ''){
			return 'transparent';
		}
		if (metric) {
			return checkLimitStyleD0(metric, value, dadmValue);
		} else {
			return 'transparent';
		}
	};

}

const component = {
	templateUrl,
	controller,
	bindings: {
		model: '<',
		options: '<',
		metric: '<',
		criteria: '<'
	}
};

app.component('wfPivotTableUnifilarAll', component);